import styled from 'styled-components'
import Capa from '../../../assets/capa1.webp'

export const Page = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f7f7fb 0%, #eef0ff 45%, #fdf7f3 100%);
  padding: 2.5rem 1.25rem 4rem;
`

export const Shell = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 2.5fr) minmax(280px, 1.2fr);
  gap: 1.5rem;
  align-items: start;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`

export const Card = styled.div`
  background: #fff;
  border-radius: 20px;
  padding: 2.25rem;
  box-shadow: 0 20px 60px rgba(25, 27, 53, 0.12);
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media (max-width: 640px) {
    padding: 1.5rem;
  }
`

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(137, 118, 255, 0.12);
  color: var(--purple);
  border-radius: 999px;
  padding: 0.35rem 0.9rem;
  font-weight: 700;
  font-size: 0.875rem;
`

export const Subtitle = styled.p`
  margin: 0;
  color: #575b71;
  font-weight: 600;
`

export const Stepper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 0.75rem;
`

export const Step = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  background: #f6f7fb;
  border: 1px solid transparent;

  &.active {
    background: #ffffff;
    border-color: var(--purple);
    box-shadow: 0 8px 28px rgba(116, 92, 255, 0.15);
  }

  &.completed {
    background: #fff9f3;
    border-color: rgba(255, 132, 44, 0.35);
    box-shadow: 0 8px 28px rgba(255, 132, 44, 0.15);
  }
`

export const StepIndex = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  color: #fff;
  background: #d2d5eb;

  &.active {
    background: var(--purple);
  }

  &.completed {
    background: var(--orange);
  }
`

export const StepLabel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.1rem;

  strong {
    color: #1f2241;
    font-size: 0.95rem;
  }

  span {
    color: #6b6f83;
    font-size: 0.85rem;
  }
`

export const ReviewStrip = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  background: #f6f7fb;
  border: 1px solid #e4e7f5;
  padding: 0.75rem 1rem;
  border-radius: 14px;

  div {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;

    span {
      color: #6b6f83;
      font-weight: 600;
    }

    strong {
      color: #1f2241;
    }
  }
`

export const SecondaryButton = styled.button`
  border: 1px solid #d7dbf2;
  background: #fff;
  color: #1f2241;
  padding: 0.6rem 1rem;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: var(--purple);
    color: var(--purple);
  }
`

export const InputGroupEmpresa = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  form {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    p {
      font-size: 0.9rem;
      color: #4b4f68;
    }
  }
`

export const A = styled.a`
  text-decoration: none;
  color: #1777f2;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.25rem 1rem;
`

export const InputField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;

  &.full {
    grid-column: 1 / -1;
  }

  label {
    font-size: 0.95rem;
    font-weight: 700;
    color: #1f2241;
  }

  input {
    width: 100%;
    background: #f8f8ff;
    border: 1px solid #e4e7f5;
    color: var(--black);
    font-weight: 700;
    padding: 12px 16px;
    border-radius: 10px;
    outline-color: var(--purple);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &:focus {
      border-color: var(--purple);
      box-shadow: 0 0 0 4px rgba(116, 92, 255, 0.15);
    }
  }
`

export const InputToggle = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  input {
    padding-right: 3rem;
  }

  button {
    position: absolute;
    right: 0.75rem;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1.1rem;
    line-height: 1;
    color: #6b6f83;
    transition: color 0.2s ease, transform 0.1s ease;

    &:hover {
      color: var(--purple);
    }

    &:active {
      transform: scale(0.96);
    }
  }
`

export const SpanError = styled.div`
  font-size: 0.8rem;
  color: #d7263d;
  font-weight: 600;
`

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  button {
    min-width: 220px;
  }
`

export const SideCard = styled.div`
  position: relative;
  background: linear-gradient(160deg, rgba(98, 63, 168, 0.95), rgba(255, 132, 44, 0.85)),
    url(${Capa}) center/cover no-repeat;
  color: #fff;
  border-radius: 20px;
  padding: 2rem;
  min-height: 100%;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(39, 39, 72, 0.35);

  &:before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.12), transparent 35%),
      radial-gradient(circle at 80% 30%, rgba(255, 255, 255, 0.1), transparent 40%);
    pointer-events: none;
  }

  > * {
    position: relative;
    z-index: 1;
  }
`

export const SideBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.85rem;
  background: rgba(255, 255, 255, 0.16);
  border-radius: 999px;
  font-weight: 700;
`

export const SideTitle = styled.h3`
  margin: 1rem 0 0.5rem 0;
  font-size: 1.4rem;
  color: #fff;
`

export const SideList = styled.ul`
  margin: 0;
  padding: 0 0 0 1.25rem;
  display: grid;
  gap: 0.6rem;

  li {
    line-height: 1.4;
    font-weight: 600;
    color: #f9f9ff;
  }
`

export const Toast = styled.div`
  position: fixed;
  top: 88px;
  right: 24px;
  background: #0f172a;
  color: #f8fafc;
  border-radius: 16px;
  padding: 0.9rem 1rem;
  box-shadow: 0 15px 45px rgba(12, 18, 48, 0.4);
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  max-width: 340px;
  z-index: 999;

  @media (max-width: 640px) {
    left: 16px;
    right: 16px;
    top: 72px;
  }
`

export const ToastIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: linear-gradient(130deg, #34d399, #059669);
  display: grid;
  place-items: center;
  font-weight: 900;
  font-size: 1rem;
`

export const ToastTitle = styled.div`
  font-weight: 800;
  font-size: 0.95rem;
`

export const ToastDescription = styled.div`
  font-size: 0.9rem;
  color: #cbd5e1;
  margin-top: 0.1rem;
`

export const ToastProgress = styled.div`
  position: relative;
  margin-top: 0.6rem;
  width: 100%;
  height: 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  overflow: hidden;

  span {
    position: absolute;
    inset: 0;
    background: linear-gradient(120deg, #34d399, #10b981);
    transition: width 0.3s ease;
  }
`
